.productGrid,
.productList {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(290px, 0.8fr));
  gap: 30px;
  width: 100%;
}

.productItem {
  opacity: 0;
}

@media (max-width: 900px) {
  .productGrid,
  .productList {
    justify-content: center;
    width: 100%;
    margin: 0 auto;
    padding: 0;
  }

  /* extra safety: on mobile productItem is never invisible */
  .productItem {
    opacity: 1;
  }
}
